export const menuItems = [
  {
    id: 7,
    name: "Sausage Egg and Cheese",
    price: "$12",
    description: "Homestyle grilled sausage, scrambled eggs with your choice of cheese on a hearty roll or English muffin.",
    ingredients: ["Grilled sausage patty", "Scrambled eggs", "Choice of cheese", "Hearty roll"],
    note: "Morning only, try it with hot honey and turn it into your go to.",
    image: "https://static.readdy.ai/image/2f7bf1de0c4b28d33f2b00b2a6c4bf32/3b664eb9fc5892bcef8f9f3375599301.png",
    imagePosition: "object-center",
    category: "AM",
  },
  {
    id: 1,
    name: "The \"OG\" Cheesesteak",
    price: "$16",
    description: "Thinly sliced ribeye chopped to perfection with your choice of cheese: Provolone, American, Cooper Sharp or classic Whiz. Option to add onions, mushrooms, and/or peppers.",
    ingredients: ["Beef", "Provolone", "American", "Cooper Sharp", "Whiz"],
    note: "Classic Philadelphia flavor, always a crowd pleaser.",
    image: "https://static.readdy.ai/image/2f7bf1de0c4b28d33f2b00b2a6c4bf32/4ee27bd469fd06b51350856bcdb4f3b3.webp",
    category: "PM",
  },
  {
    id: 2,
    name: "Chicken Cheesesteak",
    price: "$15",
    description: "Thinly sliced chicken breast with your choice of cheese. Same as the OG, just for those that want to eat more chicken!",
    ingredients: ["Chicken breast", "Provolone", "American", "Cooper Sharp", "Whiz"],
    note: "An OG classic, but with chicken",
    image: "https://static.readdy.ai/image/2f7bf1de0c4b28d33f2b00b2a6c4bf32/61f47cb14310ea2ab571af948a9ef7b2.jpeg",
    category: "New",
  },
  {
    id: 3,
    name: "Chopped Impossible",
    price: "$14",
    description: "Vegetarian version of a Chopped Steak using Impossible Foods meet with choice of cheese. Comes with lettuce, tomato, fried onions and special sauce.",
    ingredients: ["Impossible Foods", "Lettuce", "Fried Onions", "Provolone", "Tomato", "House Sauce", "American"],
    note: "An East Coast favorite met with West Coast flavor.",
    image: "https://static.readdy.ai/image/2f7bf1de0c4b28d33f2b00b2a6c4bf32/9ef8d2473afd43f2a8b20804ba6c9736.jpeg",
    category: "AM",
  },
  {
    id: 4,
    name: "Royale with Cheese",
    price: "$14",
    description: "Classic burger made your way. Comes with pickles, onions, lettuce and tomato and special sauce on a brioche bun. Ask for bacon to really shake things up.",
    ingredients: ["Beef patty", "Lettuce", "Tomato", "American", "Special Sauce", "Brioche Bun"],
    note: "A smashburger made the way you want.",
    image: "https://static.readdy.ai/image/2f7bf1de0c4b28d33f2b00b2a6c4bf32/19c8481a1d729a94e58e326fe004e716.webp",
    category: "AM",
  },
];